<div class="fwc-container sae-waiver-body">
  <div class="fwc-row">
    <div class="fwc-col-12 waiver-intro">
      <h2>{{content.sectionHead}}</h2>
      <div>
        <span class="fwc-icon fwc-icon-lock-icon"> </span> {{content.sectionContent}}
      </div>
    </div>
  </div>
</div>

<div class="fwc-container sae-waiver-cards">
  <div class="fwc-row">
    <div class="fwc-col-12 fwc-card-generic flat card-container">
      <form [formGroup]="aboutYouForm" (ngSubmit)="onSubmitForm()">
        <div class="fwc-row fwc-row-bm">
          <div class="fwc-col-12">
            <h3>About You</h3>
          </div>
        </div>

        <div class="fwc-row fwc-row-bm">
          <div class="fwc-col-3 sm-12 fwc-input">
            <label for="studentId">Student ID#</label>
            @if ( myDetails?.rosterless === 1) {
              <div class="sae-masked-input">
                <input name="studentId" formControlName="studentId" id="studentId" type="text"
                  maxlength="25"  [pattern]=studentIDPatteren />
                @if (form.studentId.errors && formSubmitted) {
                  <span role="alert"
                  class="fwc-inline-icon fwc-icon-delete">Please enter a valid student ID</span>
                }
              </div>
            }
            @if ( myDetails?.rosterless === 0) {
              <div>
                {{myDetails.studentId}}
              </div>
            }
          </div>
          <div class="fwc-col-3 sm-12 fwc-input">
            <label for="firstName">First Name</label>
            <div class="sae-masked-input">
              <input name="firstName" formControlName="firstName" id="firstName" type="text"
                pattern="^[A-Za-z- ']+$" maxlength="20" />
              @if (form.firstName.errors && formSubmitted) {
                <span role="alert"
                class="fwc-inline-icon fwc-icon-delete">Please enter a valid first name</span>
              }
            </div>
          </div>
          <div class="fwc-col-3 sm-12 fwc-input">
            <label for="middleInitial">Middle Initial <span class="optionalFeild-design"> Optional</span>
          </label>
          <div class="sae-masked-input">
            <input name="middleInitial" formControlName="middleInitial" id="middleInitial"
              pattern="^[A-Za-z]+$" maxlength="1" type="text" />
            @if (form.middleInitial.errors && formSubmitted) {
              <span role="alert"
              class="fwc-inline-icon fwc-icon-delete">Please enter a valid middle initial</span>
            }
          </div>
        </div>
        <div class="fwc-col-3 sm-12 fwc-input">
          <label for="lastName">Last Name</label>
          <div class="sae-masked-input">
            <input name="lastName" formControlName="lastName" id="lastName" type="text"
              pattern="^[A-Za-z- ']+$" maxlength="25" />
            @if (form.lastName.errors && formSubmitted) {
              <span role="alert"
              class="fwc-inline-icon fwc-icon-delete">Please enter a valid last name</span>
            }
          </div>
        </div>
      </div>

      <div class="fwc-row fwc-row-bm">
        <div class="fwc-col-3 sm-12">
          <div class="fwc-select-list">
            <label for="gender">Gender</label>
            <select name="gender" id="gender" formControlName="gender">
              <option value="" selected>Select a Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Unspecified">Unspecified</option>
            </select>
            @if (form.gender.errors && formSubmitted) {
              <span role="alert"
              class="fwc-inline-icon fwc-icon-delete">Please select a valid gender</span>
            }
          </div>
        </div>
        <div class="fwc-col-3 sm-12 fwc-input">
          <label for="identifyAs">Identify As <span class="optionalFeild-design">
          Optional</span></label>
          <div class="sae-masked-input">
            <input name="identifyAs" formControlName="identifyAs" id="identifyAs" type="text"
              pattern="^[A-Za-z]+$" maxlength="255" />
            @if (form.identifyAs.errors && formSubmitted) {
              <span role="alert"
              class="fwc-inline-icon fwc-icon-delete">Please enter a valid identify as</span>
            }
          </div>
        </div>
        <div class="fwc-col-3 sm-12">
          <div class="fwc-select-list">
            <label for="academicLevel">Academic Level</label>
            <select name="academicLevel" id="academicLevel" formControlName="academicLevel">
              <!-- <option value="" selected>Select a Academic Level</option> -->
              @for (item of academicLevelValues; track item) {
                <option [value]="item.slug">{{item.label}}
                </option>
              }
              <!-- <option value="Graduated">Graduated</option> -->
            </select>
            @if (form.academicLevel.errors && formSubmitted) {
              <span role="alert"
              class="fwc-inline-icon fwc-icon-delete">Please select a valid academic level</span>
            }
          </div>
        </div>
        <div class="fwc-col-3 sm-12">

          <fwc-date-picker id="{{'dob-input'}}" attr.input-label="{{'Date of Birth'}}"
            attr.show-date="{{showStartDate}}" attr.start-date="{{datePickerStart}}"
            [invalid]="(form.DOB.errors && formSubmitted)  || ( ageError && formSubmitted)"
            (fwc-date-picker-blur)="blurEvent($event)" (fwc-date-picker-selected)="updateDob($event)">
          </fwc-date-picker>


          <div class="fwc-input">
            <input type="hidden" id="DOB" name="DOB" formControlName="DOB" />
            @if (form.DOB.errors && formSubmitted) {
              <span role="alert"
              class="fwc-inline-icon fwc-icon-delete">Please enter a date of birth</span>
            }
            @if ( ageError && formSubmitted) {
              <span role="alert"
                class="fwc-inline-icon fwc-icon-delete">Student must be 14 years of age or
              older</span>
            }
          </div>
        </div>
      </div>

      <div class="fwc-row fwc-row-bm ">
        <div class="fwc-col-4 sm-12 fwc-input">
          <label for="email">Email</label>
          <div class="sae-masked-input">
            <input name="email" formControlName="email" id="email" type="text"
              pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" maxlength="255" />
            @if (form.email.errors && formSubmitted) {
              <span role="alert"
              class="fwc-inline-icon fwc-icon-delete">Please enter a valid email</span>
            }
          </div>
        </div>
        <div class="fwc-col-3 sm-12 fwc-input">
          <label for="phoneNumber">Primary Phone</label>
          <div class="sae-masked-input">
            <input name="phoneNumber" formControlName="phoneNumber" id="phoneNumber"
              minlength="10" pattern="^[1-9]{1}[-]*[0-9][-0-9]*$" type="text"
              (keydown)="validateInput($event)" (focus)="removeHyfen($event, 'phoneNumber')"   (blur)="phoneNumberFormat($event, 'phoneNumber')" />
            @if (form.phoneNumber.errors && formSubmitted) {
              <span role="alert"
              class="fwc-inline-icon fwc-icon-delete">Primary phone should not be lesser than 10 digit</span>
            }
          </div>
        </div>
        <div class="fwc-col-3 sm-12 fwc-input">
          <label for="altPhoneNumber">Alt. Phone <span class="optionalFeild-design">
          Optional</span></label>
          <div class="sae-masked-input">
            <input name="altPhoneNumber" formControlName="altPhoneNumber" id="altPhoneNumber"
              minlength="10" pattern="^[1-9]{1}[-]*[0-9][-0-9]*$" type="text"
              (keydown)="validateInput($event)" (focus)="removeHyfen($event, 'altPhoneNumber')"    (blur)="phoneNumberFormat($event, 'altPhoneNumber')" />
            @if (form.altPhoneNumber.errors && formSubmitted) {
              <span role="alert"
              class="fwc-inline-icon fwc-icon-delete">Alt. phone should not be lesser than 10 digit</span>
            }
          </div>
        </div>
      </div>

      <div class="fwc-row">
        <div class="fwc-col-12 fwc-divider">
        </div>
      </div>
      <div class="fwc-row fwc-row-bm">
        <div class="fwc-col-12">
          <h3>Mailing Address</h3>
        </div>
      </div>

      <div class="fwc-row fwc-row-bm">

        <div class="fwc-col-3 sm-12">
          <div class="fwc-select-list">
            <label for="haveUsAddress">Do you have a US address?</label>
            <select name="haveUsAddress" id="haveUsAddress" formControlName="haveUsAddress" (change)="usAddress()">
              <option value="Yes" selected>Yes</option>
              <option value="No">No</option>
            </select>
            @if (form.haveUsAddress.errors && formSubmitted) {
              <span role="alert"
              class="fwc-inline-icon fwc-icon-delete">Please select a valid US address</span>
            }
          </div>
        </div>
        @if (aboutYouForm.value.haveUsAddress === 'Yes') {
          <div class="fwc-col-4 sm-12 fwc-input ">
            <label for="address">Address</label>
            <div class="sae-masked-input">
              <input name="address" formControlName="address" id="address" type="text" pattern="^[A-Za-z0-9., -]+$"
                maxlength="255" (blur)="validateCity($event, 'address')" />
              @if (form.address.errors && formSubmitted) {
                <span role="alert"
                class="fwc-inline-icon fwc-icon-delete">Only alphabet, numeric, comma, hyphen, dot and space  are allowed</span>
              }
            </div>
          </div>
          <div class="fwc-col-3 sm-12 fwc-input">
            <label for="address2">Suite/Apt# <span class="optionalFeild-design">
            Optional</span></label>
            <div class="sae-masked-input">
              <input name="address2" formControlName="address2" id="address2" type="text"
                maxlength="255" (blur)="validateCity($event, 'address2')" />
              @if (form.address2.errors && formSubmitted) {
                <span role="alert"
                class="fwc-inline-icon fwc-icon-delete">Please enter a valid suite/apt#</span>
              }
            </div>
          </div>
        }
      </div>

      @if (aboutYouForm.value.haveUsAddress === 'Yes') {
        <div class="fwc-row fwc-row-bm">
          <div class="fwc-col-3  sm-12 fwc-input">
            <label for="city">City</label>
            <div class="sae-masked-input">
              <input name="city" formControlName="city" id="city" type="text" pattern="^[A-Za-z ]+$"
                maxlength="25" (blur)="validateCity($event, 'city')" />
              @if (form.city.errors && formSubmitted) {
                <span role="alert"
                class="fwc-inline-icon fwc-icon-delete">Please enter a valid city</span>
              }
            </div>
          </div>
          <div class="fwc-col-3 sm-12">
            <div class="fwc-select-list">
              <label for="state">State</label>
              <select name="state" id="state"  formControlName="state">
                <option value="" selected >Select state</option>
                @for (state of statesData; track state) {
                  <option value="{{state.key}}"
                  [attr.selected]="state.key==myDetails?.state ? true : null">{{state.value}}</option>
                }
              </select>
              @if (form.state.errors && formSubmitted) {
                <span role="alert"
                class="fwc-inline-icon fwc-icon-delete">Please select a valid state</span>
              }
            </div>
          </div>
          <div class="fwc-col-3 sm-12 fwc-input fwc-input-icon" >
            <label for="zip">Enter your ZIP Code</label>
            <div class="sae-masked-input">
              <span class="sae-icon">   <img src="assets/images/location-pin.png" alt=""> </span>
              <input name="zip" formControlName="zip" id="zip" placeholder="ZIP Code" type="text"
                pattern="[0-9]+" minlength="5" maxlength="5" />
            </div>
            @if (form.zip.errors && formSubmitted) {
              <span role="alert"
              class="fwc-inline-icon fwc-icon-delete">Please enter a valid ZIP code</span>
            }
          </div>
          <!-- <div class="fwc-col-3 sm-12 fwc-input fwc-input-icon">
          <label for="zip">Enter your ZIP Code</label>
          <span class="fwc-icon location-pin">
            <img src="assets/images/location-pin.png" alt="">
          </span>
          <input name="zip" formControlName="zip" id="zip" placeholder="ZIP Code" type="text"
            pattern="[0-9]+" minlength="4" maxlength="10" />
          <span role="alert" *ngIf="form.zip.errors && formSubmitted"
          class="fwc-inline-icon fwc-icon-delete">Please enter a valid ZIP code</span>
        </div> -->
      </div>
    }

    @if (aboutYouForm.value.haveUsAddress === 'No') {
      <div class="fwc-row fwc-row-bm">
        @if (myDetails && myDetails.universityInfo) {
          <div class="fwc-col-12">
            <div class="btm-xxs"> <strong>The mailing address specified by your university will be
            used</strong> </div>
            <div>{{myDetails.universityInfo.address}}</div>
            <div> {{myDetails.universityInfo.address2}}</div>
            <div> {{myDetails.universityInfo.address3}}</div>
            <div>{{myDetails.universityInfo.city}}, {{myDetails.universityInfo.state}}.
            {{myDetails.universityInfo.zip}}</div>
          </div>
        }
      </div>
    }
    @if (myDetails?.showEmergencyContact === 1) {
      <div class="fwc-row">
        <div class="fwc-col-12 fwc-divider">
        </div>
      </div>
      <div class="fwc-row fwc-row-bm">
        <div class="fwc-col-12">
          <h3>Emergency Contact<span class="optionalFeild-design"> Optional</span></h3>
        </div>
      </div>
      <div class="fwc-row fwc-row-bm">
        <div class="fwc-col-3  sm-12 fwc-input">
          <label for="emergencyFirstName">First Name</label>
          <div class="sae-masked-input">
            <input name="emergencyFirstName" formControlName="emergencyFirstName"
              pattern="^[A-Za-z- ']+$" maxlength="20" id="emergencyFirstName" type="text" />
            @if (form.emergencyFirstName.errors && formSubmitted) {
              <span role="alert"
              class="fwc-inline-icon fwc-icon-delete">Please enter a valid first name</span>
            }
          </div>
        </div>
        <div class="fwc-col-3 sm-12  fwc-input">
          <label for="emergencyLastName">Last Name</label>
          <div class="sae-masked-input">
            <input name="emergencyLastName" formControlName="emergencyLastName" id="emergencyLastName"
              type="text" pattern="^[A-Za-z- ']+$" maxlength="25" />
            @if (form.emergencyLastName.errors && formSubmitted) {
              <span role="alert"
              class="fwc-inline-icon fwc-icon-delete">Please enter a valid last name </span>
            }
          </div>
        </div>
        <div class="fwc-col-3 sm-12 fwc-input">
          <label for="emergencyRelationship">Relationship</label>
          <div class="sae-masked-input">
            <input name="emergencyRelationship" formControlName="emergencyRelationship"
              id="emergencyRelationship" type="text" pattern="^[A-Za-z- ']+$" maxlength="25" />
            @if (form.emergencyRelationship.errors && formSubmitted) {
              <span role="alert"
              class="fwc-inline-icon fwc-icon-delete">Please enter a valid relationship</span>
            }
          </div>
        </div>
        <div class="fwc-col-3 sm-12  fwc-input">
          <label for="emergencyPhone">Phone</label>
          <div class="sae-masked-input">
            <input name="emergencyPhone" formControlName="emergencyPhone" id="emergencyPhone"
              minlength="10" pattern="^[1-9]{1}[-]*[0-9][-0-9]*$"  type="text"
              (keydown)="validateInput($event)" (focus)="removeHyfen($event, 'emergencyPhone')"  (blur)="phoneNumberFormat($event, 'emergencyPhone')" type="text" />
            @if (form.emergencyPhone.errors && formSubmitted) {
              <span role="alert"
              class="fwc-inline-icon fwc-icon-delete">Phone should not be lesser than 10 digit</span>
            }
          </div>
        </div>
      </div>
      <div class="fwc-row fwc-row-bm">
        <div class="fwc-col-4 sm-12 fwc-input ">
          <label for="emergencyEmail">Email </label>
          <div class="sae-masked-input">
            <input name="emergencyEmail" formControlName="emergencyEmail" id="emergencyEmail"
              type="text" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" maxlength="255" />
            @if (form.emergencyEmail.errors && formSubmitted) {
              <span role="alert"
              class="fwc-inline-icon fwc-icon-delete">Please enter a valid email</span>
            }
          </div>
        </div>
      </div>
    }

  </form>
</div>
</div>
</div>
@if (displaySpinner) {
  <div class="ant-ui-widget-overlay"></div>
  <div class="ant-ajax-loader">
    <fwc-preloader></fwc-preloader>
  </div>
}